import { useContext } from 'react';

import { GlobalContext, ProjectContext } from '@tmh-website/shared';
import { isAudience } from '@tmh-website/shared/helpers';
import { Project } from '@tmh-website/shared/const';

import type { LogoComponent, LogoId } from './useLogoComponent.contracts';
import { getLogoComponentByProject, getLogoIdByAudience } from './useLogoComponent.helpers';

/**
 * Resolves the applicable logo component based on the currently-active project.
 */
export const useLogoComponent = (): LogoComponent => {
  const { audience: currentAudience, audiences } = useContext(GlobalContext);
  const { project } = useContext(ProjectContext);

  const isLogoDependentOnAudiences: boolean = project === Project.Website;

  if (!isLogoDependentOnAudiences || !isAudience(currentAudience) || !Array.isArray(audiences)) {
    return getLogoComponentByProject(project);
  }

  const currentAudienceLogoId: LogoId = getLogoIdByAudience(currentAudience, audiences);
  const logoComponent: LogoComponent = getLogoComponentByProject(project, currentAudienceLogoId);

  return logoComponent;
};
